import defaultReducer from "./defaultReducer";

const initialState = {
  open: false,
  showDropdown: false,
  selectedProfile: null,
  selectedOperator: null,
  profileBySite: null,
  profileOptions: [],
  profileValue: null,
  row: null,
  loading: false,
};

export default defaultReducer("SITE_ALLOCATED_MODAL", initialState);
